export default function Footer() {
  return (

    <footer className="footer">
      &copy; 2025 Soilthm - Todos os direitos reservados.
    </footer>
  );
}